import React, { forwardRef, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Typography,
  IconButton,
  Pagination,
  Box,
  Grid,
  Button,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
  Slide,
  useTheme,
} from "@mui/material";
import { Edit, Delete, Add } from "@mui/icons-material";
import NavigationTab from "../navigation";
import { Users } from "./userinterface";
import AddUserDialog from "./adduser";
import EditUserDialog from "./updateuser";
import { jwtDecode } from "jwt-decode";
import { TransitionProps } from "@mui/material/transitions";
import {
  Close,
} from "@mui/icons-material";
import {Transition , Transitioncon} from "../assets/assets"

const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: "bold",
  color: "black",
}));


interface Decodedtoken {
  id: number;
  [key: string]: any;
}
interface UserToggle {
  id: number;
  status: boolean;
  name: string;
}

const UserListTable: React.FC = () => {
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [kcl, setkcl] = useState<boolean>(false);
  const [allUsers, setAllUsers] = useState<Users[]>([]);
  const [users, setUsers] = useState<Users[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<Users | null>(null);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [userToToggle, setUserToToggle] = useState<UserToggle | null>(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState<Users | null>(null);
  const [currentuserId, setCurrentUserId] = useState<number | null>(null);
  const theme = useTheme();
  const fetchUsers = (currentPage: number) => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/user/getUserPagination`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pageNo: currentPage,
        pageSize: pageSize,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Filter out users whose role.name is 'super_admin'
        const filteredUsers = (data.items || []).filter(
          (user: Users) => user.role?.name !== 'kinetic_admin'
        );
    
        // Sort the filtered users by ID in ascending order
        const sortedUsers = filteredUsers.sort((a: Users, b: Users) => a.id - b.id);
    
        setUsers(sortedUsers);
        setTotalCount(data.totalCount || 0);
      })
      .catch((error) => console.error("Error fetching users:", error));
    
  };
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded: Decodedtoken = jwtDecode(token);
        setCurrentUserId(decoded.id);
      } catch (error) {
        console.log('Invalid Token:', token);
      }
    }
  }, []);
  
  const filteredUsers = users.filter(
    user => user.id !== currentuserId 
  );
  
  useEffect(() => {
    fetchUsers(page);
  }, [page]);
  


  const handleUserAdded = () => {
    fetchUsers(page);
  };

  const handleUserUpdated = () => {
    fetchUsers(page);
  };

  const handleEditUser = (user: Users) => {
    setSelectedUser(user);
    setEditDialogOpen(true);
  };
  const handleStatusChangeConfirm = () => {
    if (!userToToggle) return;
    console.log("Changing status for user ID:", userToToggle.id);
    console.log("Current status:", userToToggle.status);
    console.log("New status:", !userToToggle.status);
  
    // Corrected URL formatting
    fetch(`${process.env.REACT_APP_API_BASE_URL}/user/userStatusChangeWTHT/${userToToggle.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status: !userToToggle.status }), // Toggle the status
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to update user status");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Status updated successfully:", data);
  
        // Update the local state only if the API call was successful
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === userToToggle.id ? { ...user, status: !userToToggle.status } : user
          )
        );
        fetchUsers(page); // Fetch updated users
        setStatusDialogOpen(false);
      })
      .catch((error) => {
        console.error("Error updating status:", error);
      });
  };

  const handleStatusChangeRequest = (user: Users) => {
    setUserToToggle({ id: user.id, status: user.status, name: user.name });
    setStatusDialogOpen(true);
  };

  const handleDeleteUser = (userId: number) => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/user/${userId}`, {
      method: 'DELETE',
    })
      .then((response) => {
        if (response.ok) {
          fetchUsers(page);
          setOpenDeleteDialog(false);
        } else {
          console.error('Error deleting user');
        }
      })
      .catch((error) => console.error('Error deleting user:', error));
  };

  const openDeleteDialogHandler = (user: Users) => {
    setUserToDelete(user);
    setOpenDeleteDialog(true);
  };

  const closeDeleteDialogHandler = () => {
    setUserToDelete(null);
    setOpenDeleteDialog(false);
  };
  return (
    <Box sx={{ background: "#EEEEEE", paddingBottom: 8 }}>
      <NavigationTab />
      <Grid container sx={{ marginTop: 8 }}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", background: "transparent" }}>
          <Box sx={{ width: "1200px", background: "white", border: "0.5px solid red", borderRadius: "18px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
              <Typography variant="h6" sx={{ color: "black" }}>User List</Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                sx={{ borderRadius: "20px", background: "white", color: "black", border: "0.5px red solid" }}
                onClick={() => setDialogOpen(true)}
              >
                Add User
              </Button>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ background: "red" }}>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Active/Inactive</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>User Name</TableCell>
                    {/* <TableCell sx={{ color: "white", fontWeight: "bold" }}>ROLE</TableCell> */}
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>STATUS</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>ACTION</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUsers.map((user, index) => (
                    <TableRow
                      key={user.id}
                      sx={{ backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff' }}
                    >
                      <StyledTableCell>
                        <Switch
                          checked={user.status}
                          onChange={() => handleStatusChangeRequest(user)}
                          color="primary"
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ paddingRight: 3 }}>
                            <Avatar sx={{ bgcolor: "white", color: "black" }} />
                          </Box>
                          <Box sx={{ textAlign: "left" }}>
                            <Typography variant="body1">{user.name}</Typography>
                            {/* <Typography variant="body2">ID {user.id}</Typography> */}
                          </Box>
                        </Box>
                      </StyledTableCell>
                      {/* <StyledTableCell>{user.role.name}</StyledTableCell> */}
                      <StyledTableCell>
                        <Typography>
                          {user.status ? "Active" : "Inactive"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton onClick={() => handleEditUser(user)}>
                          <Edit sx={{ color: "black" }} />
                        </IconButton>
                        <IconButton onClick={() => openDeleteDialogHandler(user)}>
                          <Delete sx={{ color: "red" }} />
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2 }}>
              <Pagination
                count={Math.ceil(totalCount / pageSize)}
                page={page}
                onChange={(event, value) => setPage(value)}
                color="primary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "white",
                    backgroundColor: "red",
                    borderRadius: "8px",
                    margin: "0 4px",
                  },
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "black",
                    color: "white",
                  },
                  "& .MuiPaginationItem-root:hover": {
                    backgroundColor: "green",
                  },
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Status Change Confirmation Dialog */}
      <Dialog
        open={statusDialogOpen}
        TransitionComponent={Transitioncon}
        onClose={() => setStatusDialogOpen(false)}
        keepMounted
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 90,
            background: theme.palette.background.paper,
            transition: 'transform 0.3s ease',
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)',
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(144deg, rgba(252, 133, 69, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 133, 69, 0.87) 100%)",
            px: 2,
            py: 1,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
          }}
        >
          <DialogTitle sx={{ color: "white", p: 0, fontWeight: 'bold', fontSize: '1.5rem' }}>Change User Status</DialogTitle>
          <IconButton onClick={() => setStatusDialogOpen(false)} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          <Typography>
            Are you sure you want to{" "}
            <strong style={{ color: pendingStatus ? "green" : "red" }}>
              {userToToggle?.status ? "Deactivate" : "Activate"} 
            </strong>{" "}
            <strong>{userToToggle?.name}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>

          <Button
            onClick={handleStatusChangeConfirm}
            sx={{
              background: "linear-gradient(144deg, rgba(252, 133, 69, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 133, 69, 0.87) 100%)",
              '&:hover': {
                background: "linear-gradient(144deg, rgba(253, 29, 29, 1) 0%, rgba(252, 133, 69, 1) 50%, rgba(253, 29, 29, 0.87) 100%)", // Hover effect
              },
              color: "white"
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* delete */}

      <Dialog 
        open={openDeleteDialog} 
        onClose={closeDeleteDialogHandler} 
        TransitionComponent={Transitioncon}
        >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(144deg, rgba(252, 133, 69, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 133, 69, 0.87) 100%)",
            px: 2,
            py: 1,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
          }}
        >
          <DialogTitle sx={{ color: "white", p: 0, fontWeight: 'bold', fontSize: '1.5rem' }}>Confirm Deletion</DialogTitle>
          <IconButton onClick={() => closeDeleteDialogHandler()} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </Box>

        <DialogContent>
          <Typography>Are you sure you want to delete {userToDelete?.name}?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => userToDelete && handleDeleteUser(userToDelete.id)}
            sx={{
              background: "linear-gradient(144deg, rgba(252, 133, 69, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 133, 69, 0.87) 100%)",
              '&:hover': {
                background: "linear-gradient(144deg, rgba(253, 29, 29, 1) 0%, rgba(252, 133, 69, 1) 50%, rgba(253, 29, 29, 0.87) 100%)", // Hover effect
              },
              color: "white"
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <AddUserDialog open={dialogOpen} onClose={() => setDialogOpen(false)} onUserAdded={handleUserAdded} />
      <EditUserDialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} user={selectedUser} onUserUpdated={handleUserUpdated} />
    </Box>
  );
};

export default UserListTable;

